import { render, staticRenderFns } from "./FlowModule.vue?vue&type=template&id=a54408ce"
import script from "./FlowModule.vue?vue&type=script&lang=js"
export * from "./FlowModule.vue?vue&type=script&lang=js"
import style0 from "./FlowModule.vue?vue&type=style&index=0&id=a54408ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports